var _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductScheduleChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 48216637"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42
  })), /*#__PURE__*/React.createElement("g", {
    id: "g810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2881_53051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 27,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path816",
    d: "M8 7.59039H34.4096V34H8V7.59039Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2881_53051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "M33.3776 20.6408V10.6856H9.03125V32.9688H20.0181",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "M14.2422 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path830",
    d: "M28.168 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path834",
    d: "M9.08203 15.8438H33.3768",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "M21.2031 12.748V8.62154",
    stroke: "black",
    strokeWidth: 2.2008,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 6674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.6093 29.8788C29.9135 29.8788 30.16 29.6322 30.16 29.3281C30.16 29.0239 29.9135 28.7773 29.6093 28.7773C29.3052 28.7773 29.0586 29.0239 29.0586 29.3281C29.0586 29.6322 29.3052 29.8788 29.6093 29.8788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.8124 29.8788C32.1166 29.8788 32.3632 29.6322 32.3632 29.3281C32.3632 29.0239 32.1166 28.7773 31.8124 28.7773C31.5083 28.7773 31.2617 29.0239 31.2617 29.3281C31.2617 29.6322 31.5083 29.8788 31.8124 29.8788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.4062 29.8788C27.7104 29.8788 27.9569 29.6322 27.9569 29.3281C27.9569 29.0239 27.7104 28.7773 27.4062 28.7773C27.102 28.7773 26.8555 29.0239 26.8555 29.3281C26.8555 29.6322 27.102 29.8788 27.4062 29.8788Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.4639 24.9219H25.7537C25.3156 24.9219 24.8953 25.0959 24.5855 25.4058C24.2756 25.7156 24.1016 26.1359 24.1016 26.5741V34.8349C24.1017 34.9325 24.1278 35.0283 24.1772 35.1125C24.2265 35.1967 24.2974 35.2663 24.3824 35.3141C24.4647 35.3607 24.5577 35.3854 24.6523 35.3857C24.7511 35.3856 24.8482 35.359 24.9332 35.3086L27.4059 33.8106C27.4973 33.7562 27.6025 33.7294 27.7088 33.7335H33.4639C33.9021 33.7335 34.3223 33.5594 34.6322 33.2496C34.942 32.9397 35.1161 32.5195 35.1161 32.0813V26.5741C35.1161 26.1359 34.942 25.7156 34.6322 25.4058C34.3223 25.0959 33.9021 24.9219 33.4639 24.9219ZM34.0146 32.0813C34.0146 32.2274 33.9566 32.3675 33.8533 32.4707C33.75 32.574 33.61 32.632 33.4639 32.632H27.7088C27.408 32.6318 27.1129 32.7137 26.8552 32.8689L25.203 33.8602V26.5741C25.203 26.428 25.261 26.2879 25.3643 26.1846C25.4676 26.0814 25.6077 26.0233 25.7537 26.0233H33.4639C33.61 26.0233 33.75 26.0814 33.8533 26.1846C33.9566 26.2879 34.0146 26.428 34.0146 26.5741V32.0813Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.550726
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductScheduleChoice);
export default __webpack_public_path__ + "static/media/icon_product_schedule_choice.bda1aaa281a923ae1d99161ad24d3ea7.svg";
export { ForwardRef as ReactComponent };